import {Brochure} from "@/types/dto/common/brochure";

export const isCheckedByCode = (selected: Brochure[], code: string) =>
  selected.some((b) => b.brochureCode === code);

const addByCode = (selected: Brochure[], brochure: Brochure) => {
  if (isCheckedByCode(selected, brochure.brochureCode)) return selected;
  return [...selected, brochure];
};

const removeByCode = (selected: Brochure[], code: string) =>
  selected.filter((b) => b.brochureCode !== code);

export const toggleValue = (
  selected: Brochure[],
  brochure: Brochure,
  checked: boolean,
  maximumOrder: number
) => {
  if (checked) {
    // Enforce the max limit on add
    if (selected.length >= maximumOrder) return selected;
    return addByCode(selected, brochure);
  } 
    return removeByCode(selected, brochure.brochureCode);
};